import { FC } from "react";
import "./card.scss";

interface ICard {
  children: JSX.Element;
  className?: string;
  isLoading?: boolean; // Add loading prop
}

export const Card: FC<ICard> = ({ children, className = "", isLoading = false }) => {
  return (
    <div className={`simplici-auth-card ${className}`}>
      {isLoading && <div className="card-top-loader" />}
      {children}
    </div>
  );
};
